
<div bsModal style="overflow: auto;"
     #assignAssessmentNew="bs-modal"
     id="purchaseAssessment" class="modal fade"
     (onShown)="onShown()" role="dialog"
     aria-labelledby="purchaseAssessment"
     aria-hidden="true"
     [config]="{backdrop: 'static'}">
    <div class="modal-dialog">

        <div #modalContent class="modal-content">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="showConfirmCloseRatersModal(true)" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center">Assign Assessments</h2>
            </div>

            <div class="modal-body">
                <ng-container *ngIf="!_Globals.assignAssessmentsForImportClients">
                    <div *ngIf="displayHeaders" [ngClass]="{'hide': pageIndex != 0 }" class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom" style="color: #333;">
                        <!--<p style="margin: 0;">Business / Regular / 2.0</p>-->
                        <p style="margin:0;"><b>{{assessmentName}}</b></p>
                        <div>
                            <p><b>Amount: </b><span><b>{{currentAmount}}</b></span></p>
                        </div>
                    </div>

                    <ng-container *ngIf="loadingClients; else loadingClients;">
                        <div class="page1" [ngClass]="{'show': pageIndex == 0, 'hide': pageIndex != 0 }">

                            <div *ngIf="!displayTheAssessmentsTable">
                                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                                    <h5 style="margin-top:0;margin-top:-6px;">Client</h5>
                                    <div class="btns-container">
                                        <!--<a id="cShowFilter" (click)="toggleFilter()" class="d-none d-sm-inline-block btn btn-primary btn-sm  shadow-sm margin-right-5">
                                            <i *ngIf="!enableFilter" class="fas fa-filter text-white-50"> <span class="button-text"> Search</span></i>
                                            <i *ngIf="enableFilter" class="fas fa-filter text-white-50"> <span class="button-text"> Hide Search</span></i>
                                        </a>-->
                                        <a (click)="showAddClientModal()" class="d-none d-sm-inline-block btn btn-primary btn-sm shadow-sm margin-right-5">
                                            <i class="fas fa-plus text-white-50"> <span class="button-text"> Add Client</span></i>
                                        </a>
                                    </div>
                                </div>
                                <span *ngIf="is360" style="position:relative;top:-25px;font-size:13px;">For the ELI 360 this is the individual being rated</span>

                                <div id="clientsModalGrid" style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #clientsGrid
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="false"
                                                     [floatingFilter]="true"
                                                     [gridOptions]="clientsGridOptions"
                                                     [rowData]="clients"
                                                     [columnDefs]="clientsHeaders"
                                                     [enableSorting]="false"
                                                     [enableColResize]="false"
                                                     (rowClicked)="onRowClicked($event)"
                                                     (gridReady)="onGridReady($event)"
                                                     [pagination]="true"
                                                     [paginationPageSize]="25"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                     [rowSelection]="rowSelection"
                                                     (selectionChanged)="onSelectionChanged($event)">
                                    </ag-grid-angular>
                                </div>
                            </div>

                            <div *ngIf="displayTheAssessmentsTable">
                                <h5>Assessments</h5>
                                <div *ngIf="parent.rowCountData.length<=1" class="assessmentTabs">
                                    <ul class="tab-nav" id="assessmentTypes">
                                        <li (click)="selectedTab(1)" class="active"><a data-toggle="tab" href="#assessmentTab1">ELI - Self Assessment</a></li>
                                        <li (click)="selectedTab(2)"><a data-toggle="tab" href="#assessmentTab2">ELI 360</a></li>
                                    </ul>
                                </div>

                                <div class="main-tab-content tab-content assessmentTabs">
                                    <div id="assessmentTab1" class="tab-pane fade in active">
                                        <div style="width: 100%; max-height: 400px; height:400px;">
                                            <ag-grid-angular #assessmentsGrid
                                                             style="width: 100%; height: 100%;"
                                                             class="ag-theme-balham"
                                                             [enableFilter]="false"
                                                             [gridOptions]="gridOptions"
                                                             [rowData]="assessmentsELIData"
                                                             [columnDefs]="assessmentsHeaders"
                                                             [enableSorting]="false"
                                                             [enableColResize]="false"
                                                             (rowClicked)="onAssessessmentRowClicked($event)"
                                                             (gridReady)="assessmentsOnGridReady(1,$event)"
                                                             [pagination]="true"
                                                             [paginationPageSize]="25"
                                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                             [rowSelection]="assessmentsRowSelection"
                                                             (selectionChanged)="onAssessmentsSelectionChanged(1, $event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>

                                    <div id="assessmentTab2" class="tab-pane fade">
                                        <div style="width: 100%; max-height: 400px; height:400px;">
                                            <ag-grid-angular #assessmentsGrid
                                                             style="width: 100%; height: 100%;"
                                                             class="ag-theme-balham"
                                                             [enableFilter]="false"
                                                             [gridOptions]="gridOptions"
                                                             [rowData]="assessments360Data"
                                                             [columnDefs]="assessmentsHeaders"
                                                             [enableSorting]="false"
                                                             [enableColResize]="false"
                                                             (rowClicked)="onAssessessmentRowClicked($event)"
                                                             (gridReady)="assessmentsOnGridReady(2,$event)"
                                                             [pagination]="true"
                                                             [paginationPageSize]="25"
                                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                             [rowSelection]="assessmentsRowSelection"
                                                             (selectionChanged)="onAssessmentsSelectionChanged(2, $event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                                <!--<div style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #assessmentsGrid
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="false"
                                                     [gridOptions]="gridOptions"
                                                     [rowData]="assessments"
                                                     [columnDefs]="assessmentsHeaders"
                                                     [enableSorting]="false"
                                                     [enableColResize]="false"
                                                     (rowClicked)="onAssessessmentRowClicked($event)"
                                                     (gridReady)="onGridReady($event)"
                                                     [pagination]="true"
                                                     [paginationPageSize]="25"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                     [rowSelection]="assessmentsRowSelection"
                                                     (selectionChanged)="onAssessmentsSelectionChanged($event)">
                                    </ag-grid-angular>
                                </div>-->
                            </div>

                        </div>
                    </ng-container>

                    <ng-template #loadingClients>
                        <div class="loading text-center">
                            <br />
                            <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                            <br />
                            <p>Loading, please wait...</p>
                        </div>
                    </ng-template>

                </ng-container>

                <div [ngClass]="{'show': pageIndex == 1, 'hide': pageIndex != 1 }" *ngIf="!_Globals.assignAssessmentsForImportClients">
                    <div class="row">
                        <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                            <h5></h5>
                            <div class="btns-container">
                                <a (click)="openAddRelationshipsModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary margin-right-5">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text"> Add Relationship</span></i>
                                </a>
                                <!--<a (click)="openRaterTypesForModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary margin-right-5">
                                    <i class="fas fa-edit text-white-50"> <span class="button-text"> Manage Relationships</span></i>
                                </a>-->
                                <!--<a (click)="openRaterTypesForModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary margin-right-5">
                                    <i class="fas fa-folder-open text-white-50"> <span class="button-text"> Relationships</span></i>
                                </a>
                                <a (click)="showImportModal(2)" class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm margin-right-5">
                                    <i class="fas fa-file-import text-white-50"> <span class="button-text"> Import raters</span></i>
                                </a>
                                <a (click)="showDeleteRatersConfirmationModal()" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5" [ngClass]="{'btn-red': canDeleteRaters, 'btn-gray': !canDeleteRaters}">
                                    <i class="fas fa-user-times text-white-50"> <span class="button-text"> Delete</span></i>
                                </a>
                                <a *ngIf="addedRaters.length > 0" (click)="showNewRaterModal('Edit')" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-other': canEdit, 'btn-gray': !canEdit}">
                                    <i class="fas fa-edit text-white-50"> <span class="button-text"> Edit</span></i>
                                </a>
                                <a (click)="showNewRaterModal('Add')" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text"> Add</span></i>
                                </a>-->
                            </div>
                        </div>
                    </div>

                    <br />

                    <div class="assignAcc">
                        <br />
                        <div *ngIf="noRaters" class="text-center" style="color:red;"><p>Please click the + Add Relationship button to add a Relationship Category</p></div>
                        <div class="categories"></div>
                        <div class="panel-group" id="assignMainAccordion" style="max-height:350px;min-height:350px;overflow-y: scroll; overflow-x:hidden;margin-bottom: -10px;margin-top:-10px;padding-bottom: 5px;">
                            <div id="forFirstelement"></div>
                            <div class="panel panel-default accHide" style="display:none;" id="acc{{rt.Id}}" *ngFor="let rt of raterTypes; let i = index;">
                                <div style="height:35px;" class="accDiv">
                                    <a (click)="drawData(rt.Id, rt.Min, $event)"
                                       [href]="'#assignMainAccordion'+i"
                                       aria-expanded="false"
                                       data-toggle="collapse"
                                       data-parent="#assignMainAccordion"
                                       [id]="rt.Id" class="panel-heading fieldsTitle collapsed">
                                        <div style="position: relative;top: -20px;" class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                                            <h4 class="panel-title">
                                                {{rt.Name}}
                                            </h4>
                                            <i class="fas fa-angle-down"></i>
                                        </div>
                                    </a>
                                </div>
                                <div [id]="'assignMainAccordion'+i" class="panel-collapse collapse" style="margin-left: -15px;">
                                    <div class="panel-body">
                                        <div class="categoryMinMessage"><span style="position:relative; top:3px; color:red;"></span></div>
                                        <div style="overflow:auto;line-height: 0;padding-top: 25px;">
                                            <div class="row text-left" style="top:-12px;position:relative;display:inline-flex; width:100%;">
                                                <div class="" style="padding: 0 0 0 3px;width:25%;min-width:150px;"><label>First Name</label></div>
                                                <div class="" style="padding: 0 0 0 10px;width:25%;min-width:150px;"><label>Last Name</label></div>
                                                <div class="" style="padding: 0 10px 0 10px;width:30%;min-width:150px;"><label>Email</label></div>
                                                <div class="row dinamicResponsive" style="width:20%;"></div>
                                            </div>
                                            <div class="assignCategoryEntries" #entries></div>
                                        </div>
                                        <div>
                                            <div>
                                                <a style="margin: 10px 0px;" (click)="addNewRaterEntry(rt.Id)" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                                    <i class="fas fa-plus text-white-50"> <span class="button-text"> Add</span></i>
                                                </a>
                                            </div>
                                            <a style="padding-left: 2px;text-decoration: underline;cursor: pointer;" (click)="showBulkDeleteRatersConfirmationModal(rt.Id)"><span class="removeButtonText">Remove Relationship</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <!--<div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                        <a style="text-decoration: underline;cursor: pointer;" (click)="showImportModal(2)" class="d-none d-sm-inline-block"> Import raters</a>
                        <div class="btns-container">
                        </div>
                    </div>-->
                    <!--*ngIf="raterGridApi.rowModel.rowsToDisplay.length > 0"-->
                    <!--<div class="" style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #raterAgGrid
                                         [rowData]="[]"
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [gridOptions]="ratersGridOptions"
                                         [floatingFilter]="false"
                                         [rowSelection]="'multiple'"
                                         [columnDefs]="ratersHeaders"
                                         (rowClicked)="onRaterRowClicked($event)"
                                         (gridReady)="onRaterGridReadyModal($event)"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         (selectionChanged)="onSelectionChangedForRaters($event)">
                        </ag-grid-angular>
                    </div>-->
                </div>

                <!--<ng-container *ngIf="page2">-->
                <div class="page2" [ngClass]="{'show': pageIndex == 2, 'hide': pageIndex != 2 }">

                    <h5>Language and Dates</h5>
                    <div class="row">
                        <div class="col-sm-12 col-md-3">
                            <label>Language: </label>
                        </div>
                        <div class="col-sm-12 col-md-9" style="padding-right: 5px;">
                            <select #importLanguage id="assignLanguages">
                                <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row radios assignAssessmentsModalradios">
                        <div class="col-sm-12 col-md-3 datepicker">
                            <label style="text-align: right;">Schedule for:</label>
                        </div>
                        <div class="col-sm-12 col-md-2" style="padding-right: 5px;" id="importDatapiker">

                            <label class="container">
                                Now
                                <input type="radio" checked="checked" name="schedule" value="0">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="col-sm-12 col-md-4 responsiveRadioDiv" style="padding-left: 5px; padding-right: 5px;" id="importDivHour">
                            <label class="container responsiveRadioLabel">
                                <span style="margin-left:5px;"></span>
                                <input type="radio" name="schedule" value="1">
                                <span style="left: 18px;" class="checkmark"></span>
                            </label>
                            <!-- NEW DATE PICKER -->
                                <input id="inputDatePicker" type="date" [(ngModel)]="date1" (change)="onDateSelect(date1)" [min]="getMinDateForPicker()">
                            <!-- NEW DATE PICKER -->
                            <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event)" [(ngModel)]="date1" [settings]="settings"></angular2-date-picker> -->
                        </div>
                        <div class="col-sm-12 col-md-3" style="padding-left: 5px; padding-right: 5px;" id="importDivHour">
                            <select (change)="hourChanged()" class="blueSelect" id="assignHour">
                                <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                            </select>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-3">
                            <label>Expires in:</label>
                        </div>
                        <div class="col-sm-12 col-md-9">
                            <input id="assignExpiresIn" type="number" name="text" value="30" max="30" min="0" />
                            <span>day(s)</span>
                        </div>
                    </div>

                    <br />
                    <div class="row">
                        <div class="col-sm-12 col-md-3" style="padding:0;">
                            <h5>Tags   <i [popover]="assignHelp" class="fas fa-question-circle pointer"></i></h5>

                            <popover-content #assignHelp
                                             title="Tags"
                                             placement="right"
                                             [animation]="true"
                                             [closeOnClickOutside]="true">
                                <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                            </popover-content>
                        </div>
                        <div class="col-sm-12 col-md-7">
                            <tag-input (onFocus)="onFocusInput()"
                                       [addOnBlur]="true"
                                       [theme]="'foundation-theme'"
                                       [(ngModel)]='tags'></tag-input>
                        </div>
                        <div class="col-sm-12 col-md-2">
                            <a (click)="openTagsModal()" class="myTags">My tags</a>
                        </div>
                        <!--<div class="col-md-9">
                            <div class="tags-wrap">
                                <div *ngFor="let tag of tags; let i = index;" class="tag">
                                    {{tag}}
                                    <span title="Delete" (click)="removeTag(i, $event)">&times;</span>
                                </div>
                            </div>
                        </div>-->
                    </div>
                    <!--<div class="row">
                        <div class="col-md-9 col-md-offset-3">
                            <input #newtag
                                   type="text"
                                   id="newTag"
                                   value=""
                                   placeholder="Add tag"
                                   (keyup.enter)="addTag(newtag.value)"
                                   (keypress)="preventSpace(newtag.value, $event)" />
                        </div>
                    </div>-->



                </div>
                <!--</ng-container>-->
                <!--<ng-container *ngIf="page3">-->
                <div class="page3" [ngClass]="{'show': pageIndex == 3, 'hide': pageIndex != 3 }">
                    <div>
                        <div class="container-fluid">
                            <h5>Email Templates <i [popover]="help" class="fas fa-question-circle pointer"></i></h5>
                            <popover-content #help
                                             title="Email Templates"
                                             placement="right"
                                             [animation]="true"
                                             [closeOnClickOutside]="true">
                                <p>
                                    Emails templates assigned to the assessment are used by default.
                                    Check the "Custom" option off if you want to use a custom template for the desired action(s).
                                </p>
                            </popover-content>
                            <!--<div class="checkbox">
                                <input (change)="changeCustomTemplateStatus()" id="checkbox1" type="checkbox">
                                <label for="checkbox1">Use custom templates</label>
                            </div>-->
                        </div>

                        <div *ngIf="is360">
                            <ul class="tab-nav eTemplates">
                                <li class="active"><a data-toggle="tab" href="#templatesTab1">Client</a></li>
                                <li><a data-toggle="tab" href="#templatesTab2">Rater</a></li>
                            </ul>
                        </div>

                        <div class="tab-content eTemplates" [ngClass]="{'main-tab-content': is360}">
                            <div id="templatesTab1" class="tab-pane fade in active">
                                <!--client-->
                                <div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Invitation email:</label>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="checkbox">
                                                <input type="checkbox" id="invEma" [(ngModel)]="invEma">
                                                <label for="invEma">Custom</label>
                                            </div>
                                        </div>
                                        <ng-container *ngIf="!invEma; else tInvEma">
                                            <div class="col-sm-8">
                                                <input class="input_readonly invEma"
                                                       type="text"
                                                       [value]="templates.invitation.TemplateName"
                                                       [id]="templates.invitation.TemplateId"
                                                       disabled
                                                       [(ngModel)]="templates.invitation.TemplateName" />
                                            </div>
                                            <div class="col-sm-1">
                                                <i (click)="showPreviewModal(templates.invitation.TemplateId, 'clientInvitation')" class="material-icons">remove_red_eye</i>
                                            </div>
                                        </ng-container>

                                        <ng-template #tInvEma>
                                            <div class="col-sm-8" style="display: flex;">
                                                <span *ngIf="invitationTemplates.length == 0" class="redAsterisk">*</span>
                                                <select [(ngModel)]="invitationTemplatesModel" id="clientInvitation">
                                                    <option *ngFor="let template of invitationTemplates"
                                                            class="option"
                                                            value="{{template.Id}}">
                                                        {{template.Name}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-sm-1">
                                                <i (click)="showPreviewModal(invitationTemplatesModel, 'clientInvitation')" class="material-icons">remove_red_eye</i>
                                            </div>
                                        </ng-template>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Reminder email:</label>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="checkbox">
                                                <input type="checkbox" id="remEma" [(ngModel)]="remEma">
                                                <label for="remEma">Custom</label>
                                            </div>
                                        </div>
                                        <ng-container *ngIf="!remEma; else tRemEma">
                                            <div class="col-sm-8">
                                                <input class="input_readonly remEma"
                                                       type="text"
                                                       [value]="templates.reminder.TemplateName"
                                                       [id]="templates.reminder.TemplateId"
                                                       disabled
                                                       [(ngModel)]="templates.reminder.TemplateName" />
                                            </div>
                                            <div class="col-sm-1">
                                                <i (click)="showPreviewModal(templates.reminder.TemplateId, 'clientReminder')" class="material-icons">remove_red_eye</i>
                                            </div>
                                        </ng-container>
                                        <ng-template #tRemEma>
                                            <div class="col-sm-8" style="display: flex;">
                                                <span *ngIf="reminderTemplates.length == 0" class="redAsterisk">*</span>
                                                <select [(ngModel)]="reminderTemplatesModel" id="clientReminder">
                                                    <option *ngFor="let template of reminderTemplates" class="option" value="{{template.Id}}">{{template.Name}}</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-1">
                                                <i (click)="showPreviewModal(reminderTemplatesModel, 'clientReminder')" class="material-icons">remove_red_eye</i>
                                            </div>
                                        </ng-template>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Completion email:</label>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="checkbox">
                                                <input type="checkbox" id="resEma" [(ngModel)]="resEma">
                                                <label for="resEma">Custom</label>
                                            </div>
                                        </div>
                                        <ng-container *ngIf="!resEma; else tResEma">
                                            <div class="col-sm-8">
                                                <input class="input_readonly resEma"
                                                       type="text"
                                                       [value]="templates.result.TemplateName"
                                                       [id]="templates.result.TemplateId"
                                                       disabled
                                                       [(ngModel)]="templates.result.TemplateName" />
                                            </div>
                                            <div class="col-sm-1">
                                                <i (click)="showPreviewModal(templates.result.TemplateId, 'clientResult')" class="material-icons">remove_red_eye</i>
                                            </div>
                                        </ng-container>
                                        <ng-template #tResEma>
                                            <div class="col-sm-8" style="display: flex;">
                                                <span *ngIf="resultTemplates.length == 0" class="redAsterisk">*</span>
                                                <select [(ngModel)]="resultTemplatesModel" id="clientResult">
                                                    <option *ngFor="let template of resultTemplates" class="option" value="{{template.Id}}">{{template.Name}}</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-1">
                                                <i (click)="showPreviewModal(resultTemplatesModel, 'clientResult')" class="material-icons">remove_red_eye</i>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>

                                <!--<div *ngIf="customTemplates">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Invitation email:</label>
                                        </div>
                                        <div class="col-sm-11">
                                            <select [(ngModel)]="invitationTemplatesModel" id="clientInvitation">
                                                <option *ngFor="let template of invitationTemplates"
                                                        class="option"
                                                        value="{{template.Id}}">
                                                    {{template.Name}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-sm-1">
                                            <i (click)="showPreviewModal(invitationTemplatesModel, 'clientInvitation')" class="material-icons">remove_red_eye</i>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Reminder email:</label>
                                        </div>
                                        <div class="col-sm-11">
                                            <select [(ngModel)]="reminderTemplatesModel" id="clientReminder">
                                                <option *ngFor="let template of reminderTemplates" class="option" value="{{template.Id}}">{{template.Name}}</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-1">
                                            <i (click)="showPreviewModal(reminderTemplatesModel, 'clientReminder')" class="material-icons">remove_red_eye</i>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Completion email:</label>
                                        </div>
                                        <div class="col-sm-11">
                                            <select [(ngModel)]="resultTemplatesModel" id="clientResult">
                                                <option *ngFor="let template of resultTemplates" class="option" value="{{template.Id}}">{{template.Name}}</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-1">
                                            <i (click)="showPreviewModal(resultTemplatesModel, 'clientResult')" class="material-icons">remove_red_eye</i>
                                        </div>
                                    </div>
                                </div>-->
                            </div>

                            <div *ngIf="is360" id="templatesTab2" class="tab-pane fade">
                                <!--rater-->
                                <!--<div *ngIf="!customTemplates">-->
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label>Invitation: </label>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="checkbox">
                                            <input type="checkbox" id="ratInv" [(ngModel)]="ratInv">
                                            <label for="ratInv">Custom</label>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="!ratInv; else tRatInv">
                                        <div class="col-sm-8">
                                            <input class="input_readonly ratInv"
                                                   type="text"
                                                   [value]="raterTemplates.invitation.TemplateName"
                                                   [id]="raterTemplates.invitation.TemplateId"
                                                   disabled />
                                        </div>
                                        <div class="col-sm-1">
                                            <i (click)="showPreviewModal(raterTemplates.invitation.TemplateId, 'raterInvitation')" class="material-icons">remove_red_eye</i>
                                        </div>
                                    </ng-container>
                                    <ng-template #tRatInv>
                                        <div class="col-sm-8" style="display: flex;">
                                            <span *ngIf="raterInvitations.length == 0" class="redAsterisk">*</span>
                                            <select id="raterInvitation" [(ngModel)]="raterInvitation">
                                                <option *ngFor="let ri of raterInvitations" [selected]="ri.Id == ri" value="{{ri.Id}}">{{ri.Name}}</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-1">
                                            <i (click)="showPreviewModal(raterInvitation, 'raterInvitation')" class="material-icons">remove_red_eye</i>
                                        </div>
                                    </ng-template>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12">
                                        <label>Reminder: </label>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="checkbox">
                                            <input type="checkbox" id="ratRem" [(ngModel)]="ratRem">
                                            <label for="ratRem">Custom</label>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="!ratRem; else tRatRem">
                                        <div class="col-sm-8">
                                            <input class="input_readonly ratRem"
                                                   type="text"
                                                   [value]="raterTemplates.reminder.TemplateName"
                                                   [id]="raterTemplates.reminder.TemplateId"
                                                   disabled />
                                        </div>
                                        <div class="col-sm-1">
                                            <i (click)="showPreviewModal(raterTemplates.reminder.TemplateId, 'raterReminder')" class="material-icons">remove_red_eye</i>
                                        </div>
                                    </ng-container>
                                    <ng-template #tRatRem>
                                        <div class="col-sm-8" style="display: flex;">
                                            <span *ngIf="raterReminders.length == 0" class="redAsterisk">*</span>
                                            <select id="raterReminder" [(ngModel)]="raterReminder">
                                                <option *ngFor="let rr of raterReminders" [selected]="rr.Id == rr" value="{{rr.Id}}">{{rr.Name}}</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-1">
                                            <i (click)="showPreviewModal(raterReminder, 'raterReminder')" class="material-icons">remove_red_eye</i>
                                        </div>
                                    </ng-template>
                                </div>
                                <!--</div>-->
                                <!--<div *ngIf="customTemplates">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Invitation: </label>
                                        </div>
                                        <div class="col-sm-11">
                                            <select id="raterInvitation" [(ngModel)]="raterInvitation">
                                                <option *ngFor="let ri of raterInvitations" [selected]="ri.Id == ri" value="{{ri.Id}}">{{ri.Name}}</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-1">
                                            <i (click)="showPreviewModal(raterInvitation, 'raterInvitation')" class="material-icons">remove_red_eye</i>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Reminder: </label>
                                        </div>
                                        <div class="col-sm-11">
                                            <select id="raterReminder" [(ngModel)]="raterReminder">
                                                <option *ngFor="let rr of raterReminders" [selected]="rr.Id == rr" value="{{rr.Id}}">{{rr.Name}}</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-1">
                                            <i (click)="showPreviewModal(raterReminder, 'raterReminder')" class="material-icons">remove_red_eye</i>
                                        </div>
                                    </div>
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
                <!--</ng-container>-->

            </div>

            <div class="modal-footer">

                <!--<input (click)="close()" type="button" class="btn" name="close" value="Cancel" />-->

                <div class="text-left" *ngIf="!_Globals.assignAssessmentsForImportClients">
                    <a *ngIf="!displayTheAssessmentsTable && pageIndex == 0" (click)="showImportModal(1)" style="text-decoration:underline;">Import</a>
                </div>

                <div class="text-right">
                    <!--for other pages-->
                    <ng-container *ngIf="!_Globals.assignAssessmentsForImportClients; else importClientsAssignBack">

                        <ng-container *ngIf="pageIndex != 3">

                            <ng-container *ngIf="pageIndex != 0 && pageIndex == 2 && is360 && skeepSelection">
                                <input (click)="prev()" type="button" class="btn btn-primary waves-effect" value="Previous" />
                            </ng-container>

                            <ng-container *ngIf="pageIndex != 0  && !skeepSelection">
                                <input (click)="prev()" type="button" class="btn btn-primary waves-effect" value="Previous" />
                            </ng-container>

                            <input (click)="next(pageIndex)" type="button" class="btn btn-primary waves-effect" value="Next" [disabled]="!enoughAmount" />
                        </ng-container>
                    </ng-container>

                    <ng-template #importClientsAssignBack>
                        <ng-container *ngIf="pageIndex == 2">
                            <input (click)="showConfirmCloseRatersModal(false)" type="button" class="btn btn-primary waves-effect" value="Back" />
                        </ng-container>

                        <ng-container *ngIf="pageIndex == 2">
                            <input (click)="next(pageIndex)" type="button" class="btn btn-primary waves-effect" value="Next" [disabled]="!enoughAmount" />
                        </ng-container>

                    </ng-template>

                    <!--for fisnish button-->
                    <ng-container *ngIf="pageIndex == 3">
                        <input (click)="prev()" type="button" class="btn btn-primary waves-effect" value="Previous" />
                        <input (click)="confirmationSave()" id="assignAssessmentSaveBtn" [disabled]="saving" type="button" class="btn btn-primary waves-effect" value="Finish" />
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <!--raters types-->
    <app-rater-types-for-modal #raterTypesForModal></app-rater-types-for-modal>
</div>

<!--/*Add Relationships MODAL*/-->
<div id="assignAddRelationshipsModal" class="modal fade" tabindex="-1" role="dialog" style="overflow: auto;">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Relationships</h2>
                <button type="button" class="close" (click)="hideRelationshipsModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div *ngIf="!loading; else load;">
                    <div *ngIf="currentSelectedRelationshipsTab == 1" class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                        <p></p>
                        <div class="btns-container">
                            <a (click)="openModal('New', 0, '' )"
                               class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
                               [ngClass]="{'btn-primary': !isStandard, 'btn-gray': isStandard}">
                                <i class="fas fa-plus text-white-50"> <span class="button-text">Create Relationship</span></i>
                            </a>
                        </div>
                    </div>

                    <div class="add-rater-types-modal">
                        <ul class="tab-nav">
                            <li (click)="loadData(2)" class="active in"><a data-toggle="tab" href="#assignStandartTab1">Standard Relationships</a></li><!--standart rater types-->
                            <li (click)="loadData(1)"><a data-toggle="tab" href="#assignCustomTab2">Custom Relationships</a></li><!--my rater types-->
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div id="assignStandartTab1" class="tab-pane fade in active">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #agGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [floatingFilter]="true"
                                                 [gridOptions]="rtgridOptions"
                                                 [rowData]="raterTypesStandartData"
                                                 [columnDefs]="raterTypesStandartDataHeaders"
                                                 (rowClicked)="onRaterTypesRowClicked($event)"
                                                 (gridReady)="onRaterTypesStandartGridReady($event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [rowSelection]="'multiple'"
                                                 (selectionChanged)="onRaterSelectionChanged($event)">
                                </ag-grid-angular>
                            </div>
                        </div>
                        <div id="assignCustomTab2" class="tab-pane fade">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #agGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [floatingFilter]="true"
                                                 [gridOptions]="rtgridOptions"
                                                 [rowData]="raterTypesCustomData"
                                                 [columnDefs]="raterTypesCustomDataHeaders"
                                                 (rowClicked)="onRaterTypesRowClicked($event)"
                                                 (gridReady)="onRaterTypesCustomGridReady($event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [rowSelection]="'multiple'"
                                                 (selectionChanged)="onRaterSelectionChanged($event)">
                                </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-template #load>
                    <div class="text-center">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;"></i>
                        <p>Loading, please wait...</p>
                    </div>
                </ng-template>

                <div class="modal-footer">
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <button (click)="hideRelationshipsModal()" data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                            <button (click)="addRelationships()" type="button" class="btn btn-primary">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--NEW-EDIT RATER MODAL-->
<div id="rtcreateModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">{{action}} Relationship</h2>
                <button type="button" (click)="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <!--<div class="row" style="margin-bottom: 10px; margin-top: -5px;">
                    <div class="align-items-center justify-content-between d-sm-flex align-items-center justify-content-between mb-4">
                        <div></div>
                        <div>
                            <a *ngIf="action == 'Edit'" (click)="openConfirmationModal()" style="margin-left: 25px;" class="d-none d-sm-inline-block btn btn-sm btn-red shadow-sm margin-right-5">
                                <i class="fas fa-trash text-white-50"> <span class="button-text">Delete</span></i>
                            </a>
                            <a (click)="saveRaterType()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm   ">
                                <i class="fas fa-save text-white-50"> <span class="button-text">Save</span></i>
                            </a>
                        </div>
                    </div>
                </div>-->

                <div class="row">
                    <div class="col-xs-12 col-md-2">
                        <label>Name:</label>
                    </div>
                    <div class="col-xs-12 col-md-10" style="padding: 0;">
                        <input #ratertName
                               id="raterName"
                               (keypress)="preventSpace(ratertName.value, $event, 'raterName')"
                               [(ngModel)]="rname"
                               placeholder="Name"
                               type="text"
                               name="name"
                               value="" />
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <input data-dismiss="modal" type="button" class="btn btn-secondary" name="close" value="Cancel" />
                <input *ngIf="action == 'Edit'" (click)="openConfirmationModal()" type="button" class="btn btn-red waves-effect" value="Delete" />
                <input (click)="saveRaterType()" type="button" class="btn btn-primary waves-effect" value="Save" />
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE MODAL*/-->
<div id="cDeleteModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Delete Relationship</h2>

                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to delete this <b>Relationship</b>?</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="deleteRaterType()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE RATERS MODAL*/-->
<div id="assignConfirmDeleteRatersModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Rater</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span *ngIf="!inProgress" style="font-size:17px;">Are you sure you want to delete this rater?</span>
                <img *ngIf="inProgress" src="../../../assets/img/gif/redLoading.gif" width="50" height="50" alt="In progress..." />
                <p *ngIf="inProgress" style="font-size:12px;">Deleting...</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div *ngIf="!inProgress" class="col-md-12 text-center">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="confirmDeleteRaters()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*BULK CONFIRMATION DELETE RATERS MODAL*/-->
<div id="assignBulkConfirmDeleteRatersModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Raters</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span class="BDMessage" *ngIf="!inProgress" style="font-size:17px;">Are you sure you want to delete these raters and this category?</span>
                <img *ngIf="inProgress" src="../../../assets/img/gif/redLoading.gif" width="50" height="50" alt="In progress..." />
                <p *ngIf="inProgress" style="font-size:12px;">Deleting...</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div *ngIf="!inProgress" class="col-md-12 text-center">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="confirmBulkDeleteRaters()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE RATERS MODAL*/-->
<div id="assignConfirmCloseRatersModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Raters</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span *ngIf="!inProgress" style="font-size:17px;">You have unsaved changes.  Are you sure you want to exit?</span>
            </div>

            <div class="modal-footer">
                <div class="row text-center">
                    <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                    <button (click)="close(true)" type="button" class="btn btn-primary">Yes</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*confirmationModal Modal*/-->
<div id="confirmationModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Assign Assessments</h2>
            </div>

            <div class="modal-body text-center">
                <p *ngIf="is360; else not360;">Invitation messages will be sent to the client and raters by email. Do you want to continue?</p>
                <ng-template #not360>
                    <p>Invitation message will be sent to the client(s) by email.  Do you want to proceed?</p>
                </ng-template>
            </div>
            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="confirmationDenied()" [ngClass]="{'hide': saving }" type="button" class="btn btn-secondary">No</button>
                        <button (click)="saveAssessmentAssignment()" [disabled]="saving" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*ADD Client Modal*/-->
<div id="addClientModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Add Client</h2>
                <button type="button" class="close" (click)="closeModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-3 noPadding">
                        <label><b style="color:#000;">Email: </b></label>
                    </div>
                    <div class="col-xs-12 col-sm-9 noPadding">
                        <input email placeholder="Email" #email (keypress)="preventSpace(email.value, $event, 'email')" type="email" value="" id="email" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-3 noPadding">
                        <label><b style="color:#000;">First Name: </b></label>
                    </div>
                    <div class="col-xs-12 col-sm-9 noPadding">
                        <input placeholder="First Name" #name (keypress)="_Globals.allowOnlyNumberAndLetters($event)" type="text" value="" id="name" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-3 noPadding">
                        <label><b style="color:#000;">Last Name: </b></label>
                    </div>
                    <div class="col-xs-12 col-sm-9 noPadding">
                        <input placeholder="Last Name" #last (keypress)="_Globals.allowOnlyNumberAndLetters($event)" type="text" value="" id="last" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addClient(email.value, name.value, last.value)" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--IMPORT CLIENT MODAL-->
<div id="importModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 *ngIf="importType == 1; else imporType2" class="modal-title text-center">Import Clients</h2>
                <ng-template #imporType2>
                    <h2 class="modal-title text-center">Import Raters</h2>
                </ng-template>
                <button type="button" class="close" (click)="closeImportModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-3 col-sm-2 text-right">
                        <label><b style="color:#000;">File: </b></label>
                    </div>
                    <div class="col-xs-9 col-sm-10" style="display: inline-flex;">
                        <input type="text" class="input_readonly" id="inputFileName" style="cursor: default !important;" readonly [(ngModel)]="fileName" />
                        <div class="fileUpload btn btn-primary">
                            <span>...</span>
                            <input accept=".csv" (change)="getBlobFile($event)" type="file" class="upload" id="importClientsifile" />
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="importType == 1">
                    <div class="col-xs-9 col-xs-offset-3 col-sm-10 col-sm-offset-2">
                        <a (click)="downloadImportClientsTemplate()" style="text-decoration:underline; cursor:pointer;">Download template</a>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12" style="padding: 0 25px;">
                        <button (click)="closeImportModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="okImportClients()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*preview modal*/-->
<div id="previewModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                    <h2 class="modal-title text-center">Email Template Preview</h2>
                    <button (click)="closePreviewModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="text-right" style="text-align:right;">
                    <a *ngIf="!customize" (click)="customizeTemplate()" class="d-none d-sm-inline-block btn btn-primary btn-sm shadow-sm margin-right-5">
                        <i class="fas fa-pencil-alt text-white-50"> <span class="button-text"> Customize</span></i>
                    </a>

                    <a *ngIf="customize" (click)="updateEmailTemplate(_name.value, _type.value, _purpose.value, _userType.value)" class="d-none d-sm-inline-block btn btn-primary btn-sm shadow-sm margin-right-5">
                        <i class="fas fa-save text-white-50"> <span class="button-text"> Save</span></i>
                    </a>
                </div>
            </div>

            <div class="modal-body">
                <div id="notCustomizable">
                    <div class="row">
                        <div class="col-md-2 text-right">
                            <label for="subject">Subject: </label>
                        </div>
                        <div class="col-md-10">
                            <input class="input_readonly" readonly type="text" name="subject" id="subject" value="" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2 text-right">
                            <label for="body">Body: </label>
                        </div>
                        <div class="col-md-10">
                            <div class="bodyContainer input_readonly" id="body"></div>
                        </div>
                    </div>
                </div>
                <div id="customizable" class="displayNone">
                    <!--<div class="row">
                        <div class="col-md-2 text-right">
                            <label for="subject">Subject: </label>
                        </div>
                        <div class="col-md-10">
                            <input type="text" name="subject" id="csubject" value="" />
                        </div>
                    </div>-->


                    <div class="row">
                        <div class="col-md-2">
                            <label>Name: </label>
                        </div>
                        <div class="col-md-10">
                            <input #_name type="text" id="emailTemplateName" value="{{name}}" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <label>Assessment type: </label>
                        </div>
                        <div class="col-md-10">
                            <select disabled class="input_readonly" id="aType" #_type>
                                <!--(change)="getSelectedOptionText($event)"-->
                                <option *ngFor="let _type of types" [selected]="type == _type.Id" value="{{_type.Id}}">{{_type.Name}}</option>
                            </select>
                        </div>
                    </div>

                    <!--<div class="row">
                        <div class="col-md-2">
                            <label>Niche: </label>
                        </div>
                        <div class="col-md-10">
                            <select disabled class="input_readonly" id="aNiche" #_niche>
                                <option *ngFor="let _niche of niches" [selected]="niche == _niche.Id" value="{{_niche.Id}}">{{_niche.Name}}</option>
                            </select>
                        </div>
                    </div>-->

                    <div class="row">
                        <div class="col-md-2">
                            <label>User Type: </label>
                        </div>
                        <div class="col-md-10">
                            <select disabled class="input_readonly" id="aUserType" #_userType>
                                <option *ngFor="let _usertype of userTypes" [selected]="userType == _usertype.Id" value="{{_usertype.Id}}">{{_usertype.Name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <label>Purpose: </label>
                        </div>
                        <div class="col-md-10">
                            <select disabled class="input_readonly" id="aPurpose" #_purpose>
                                <option disabled class="input_readonly" *ngFor="let _purpose of purposes" [selected]="purpose == _purpose.Id" value="{{_purpose.Id}}">{{_purpose.Name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <label>Language: </label>
                        </div>
                        <div class="col-md-10">
                            <select disabled class="input_readonly" id="alanguages" #_languageShortCode (change)="checkData(_languageShortCode.value, _subject.value)" (focusin)="addLocalization(_languageShortCode.value, _subject.value )">
                                <option *ngFor="let _language of languages" [selected]="_language == 'en'" class="option" value="{{_language.ShortCode}}">{{_language.Name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <label>Subject: </label>
                        </div>
                        <div class="col-md-10">
                            <input #_subject
                                   (keypress)="preventSpace(_subject.value, $event, 'csubject')"
                                   (keyup)="preventSpace(_subject.value, $event, 'csubject')"
                                   type="text"
                                   id="csubject" value=""
                                   placeholder="Subject" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-8">
                            <div class="body-content">
                                <br />
                                <quill-editor #editor
                                              [(ngModel)]="editorContent"
                                              (blur)="onEditorBlured($event)"
                                              (focus)="onEditorFocused($event)"
                                              (onEditorCreated)="onEditorCreated($event)"
                                              (onContentChanged)="onContentChanged($event)"></quill-editor>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="customFields">
                                <div class="panel-group" id="accordion">

                                    <div *ngFor="let field of templateFields; let i = index" class="panel panel-default">
                                        <div class="panel-heading" data-toggle="collapse">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" data-parent="#accordion" href="#group{{i}}">{{field.Name}} Details</a>
                                            </h4>
                                        </div>
                                        <div id="group{{i}}" class="panel-collapse collapse" [ngClass]="{'in': i == 0}">
                                            <div class="panel-body">
                                                <ul>
                                                    <li *ngFor="let item of field.Fields">
                                                        <button (click)="insertCustomFields(item.Name)">{{item.Name}}</button> <!--[disabled]="isStandard"-->
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button *ngIf="customize" (click)="closePreviewModal()" style="margin-right: 25px;" type="button" data-dismiss="modal" class="btn btn-secondary">Close</button>
                        <!--<button *ngIf="customize" style="margin-right: 25px;" type="button" (click)="updateEmailTemplate(_name.value, _type.value, _purpose.value, _niche.value, _userType.value)" class="btn btn-secondary">Ok</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*tagsModal modal*/-->
<div id="tagsModalAssignAssessmentsNew" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">My tags</h2>
                <button (click)="closeTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div *ngIf="selectedCoachTags.length > 0" class="tags-wrap">
                    <div *ngFor="let tag of selectedCoachTags; let i = index;" class="tag">
                        {{tag.Text}}
                        <span title="Delete" class="animate fadeInRight" (click)="removeTag(i, tag.Text)">&times;</span>
                    </div>
                </div>

                <div *ngIf="selectedCoachTags.length === 0">
                    <input type="text" placeholder="Select tags from the table" id="placeholderInput" readonly />
                </div>

                <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #coachTagsGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="true"
                                     [gridOptions]="gridOptions"
                                     [rowData]="coachTags"
                                     [columnDefs]="coachTagsHeaders"
                                     (gridReady)="onCoachTagsGridReady($event)"
                                     [enableSorting]="true"
                                     [enableColResize]="true"
                                     [pagination]="true"
                                     [paginationPageSize]="25"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     (rowClicked)="onCoachTagsRowClicked($event)"
                                     (selectionChanged)="onCoachTagsSelectionChanged($event)"
                                     [rowSelection]="'multiple'">
                    </ag-grid-angular>
                </div>

            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addNewCoachTags()" [disabled]="selectedCoachTags.length === 0" type="button" class="btn btn-primary">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



